export default {
  props: {
    dataTestId: {
      type: String,
      default: null,
    },
  },
};
